import { Input } from '$uikit';
import { classNames as cn } from '$utils';
import { Currency } from '$shared/components';
import { CurrencyEnum } from '$store/models';
import React from 'react';
import { useTranslator } from '$hooks';
import { AmountInputProps } from '$shared/components/AmountInput/AmountInput.interface';
import './AmountInput.sass';

const DEFAULT_AMOUNT_LIST = [5, 10, 25, 100, 500];

export const AmountInput = ({
  amount,
  onInputChange,
  amountList,
  inputTip,
  title,
  currency,
  placeholder,
  onInlineButtonClick,
  isCustomAmountMode,
}: AmountInputProps) => {
  const t = useTranslator();
  const currentAmountList = amountList || DEFAULT_AMOUNT_LIST;
  const currentCurrency = currency || CurrencyEnum.EUR;

  return (
    <div className="AmountInput">
      <div className="AmountInput__title">
        {!!title && <div className="AmountInput__title__text">{title}</div>}
        {!isCustomAmountMode && !!onInlineButtonClick && (
          <div className="AmountInput__title__btn" onClick={onInlineButtonClick}>
            {t('top_up_balance_custom_amount')}
          </div>
        )}
      </div>
      <div className="AmountInput__amountWrap">
        {isCustomAmountMode ? (
          <>
            <Input
              placeholder={placeholder}
              value={amount}
              onChange={({ target }) => onInputChange((target as HTMLInputElement).value)}
              currency={currentCurrency}
              type="price"
            />
            {!!inputTip && (
              <div className="AmountInput__custom_amount__caption">{inputTip}</div>
            )}
          </>
        ) : (
          <div className="AmountInput__amount">
            {currentAmountList.map((a, i) => (
              <div
                onClick={() => onInputChange(a.toString())}
                key={i}
                className={cn('AmountInput__amount__item', {
                  active: amount === a.toString(),
                })}
              >
                <Currency amount={+a} currency={currentCurrency} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
